<script setup>
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import conversationAPI from 'dashboard/api/conversations';
import { conversationUrl, frontendURL } from 'dashboard/helper/URLHelper';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();
const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const opening = ref(false);

const openMention = async event => {
  const mention = event.target.closest?.('[data-whatsapp-jid]');
  const conversationId = route.params.conversation_id;
  if (!mention || !conversationId || opening.value) return;
  const name = mention.textContent;
  if (
    !window.confirm(
      t('CONVERSATION.WHATSAPP_MENTIONS.OPEN_CHAT_CONFIRM', { name })
    )
  )
    return;

  opening.value = true;
  try {
    const { data } = await conversationAPI.openWhatsAppMention(
      conversationId,
      mention.dataset.whatsappJid
    );
    await router.push({
      path: frontendURL(
        conversationUrl({
          accountId: route.params.accountId,
          activeInbox: route.params.inbox_id,
          id: data.conversation_id,
        })
      ),
    });
  } catch {
    useAlert(t('CONVERSATION.WHATSAPP_MENTIONS.OPEN_CHAT_ERROR'));
  } finally {
    opening.value = false;
  }
};

const onKeydown = event => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  if (!event.target.closest?.('[data-whatsapp-jid]')) return;
  event.preventDefault();
  openMention(event);
};

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(props.content).formattedMessage;
});
</script>

<template>
  <span
    v-dompurify-html="formattedContent"
    class="prose prose-bubble"
    @click="openMention"
    @keydown="onKeydown"
  />
</template>
